import React from 'react'
import Helmet from 'react-helmet'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import HTMLContainer from 'components/common/HTMLContainer/HTMLContainer'
import { H1, H2 } from 'components/common/Text/Text'
import Theme from 'components/common/Theme/Theme'
import { MAIN_HEADING_CLASS } from 'constant'
import Button from 'components/common/Button/Button'
import Icon from 'components/common/Icon/Icon'
import ArticlesAccordion from 'components/BOTArticleCategories/components/ArticlesAccordion'

// Article Page
// url: '/resource'
const BOTArticleDetails = ({
  articleDetail: { article: { name, body, schemaDetails, categoryName } = {}, article, categoriesList } = {},
  articleGeneralSchema,
  onClick,
  showAccordionModal
}) =>
  <React.Fragment>
    <Helmet>
      {Boolean(schemaDetails) && (
        <script type="application/ld+json">
          {schemaDetails}
        </script>
      )}

      {Boolean(articleGeneralSchema) && (
        <script type="application/ld+json">
          {articleGeneralSchema}
        </script>
      )}
    </Helmet>
    {
      article &&
      <Wrapper>
        <Media.Desktop>
          <ArticleAccordionWrapper>
            <ArticlesAccordion items={ categoriesList } />
          </ArticleAccordionWrapper>
        </Media.Desktop>

        <ArticleWrapper>
          <ArticleHeader>
            <TitlesWrapper>
              <Subtitle>
                {categoryName}
              </Subtitle>
              <Title
                className={ MAIN_HEADING_CLASS }
                data-at-article-title
                headline
                headline_narrow
                centered>
                { name }
              </Title>
            </TitlesWrapper>
            <Media.Mobile>
              <ExploreTopicsButton onClick={ showAccordionModal }>
                Explore Topics
              </ExploreTopicsButton>
            </Media.Mobile>

            <AppointmentButton full="mobile" narrow onClick={ onClick }>
              <AppointmentIcon asset="book-appointment-white" />
              Request Appointment
              <ArrowIcon asset="arrow-right-white-secondary" />
            </AppointmentButton>
          </ArticleHeader>

          <HTMLContainer content={ body } data-at-article-content-container />
          <AppointmentButton bottomButton narrow full="mobile" onClick={ onClick }>
            <AppointmentIcon asset="book-appointment-white" />
            Request Appointment
            <ArrowIcon asset="arrow-right-white-secondary" />
          </AppointmentButton>

        </ArticleWrapper>
      </Wrapper>
    }
  </React.Fragment>

BOTArticleDetails.propTypes = {
  articleDetail: PropTypes.shape({
    article: PropTypes.shape({
      name: PropTypes.string,
      body: PropTypes.string,
      categoryName: PropTypes.string
    })
  }),
  articleGeneralSchema: PropTypes.string,
  onClick: PropTypes.func,
  showAccordionModal: PropTypes.func
}

BOTArticleDetails.type = 'BOTArticleDetails'

export default BOTArticleDetails

const Wrapper = styled.div`
  display: flex;
  ${Mixin.responsive('margin', '50px auto 40px', '15px 16px 40px')}
  ${Mixin.responsive('padding', '0 40px', '0')}

  *,
  ::after,
  ::before {
    box-sizing: border-box;
  }

  .row {
    /* stylelint-disable-next-line value-no-vendor-prefix */
    display: -webkit-box;
    /* stylelint-disable-next-line value-no-vendor-prefix */
    display: -ms-flexbox;
    display: flex;
    /* stylelint-disable-next-line property-no-vendor-prefix */
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
  }

  .row::before,
  .row::after {
    display: table;
    content: " ";
  }

  .row::after {
    clear: both;
  }

  .col-xs-1,
  .col-sm-1,
  .col-md-1,
  .col-lg-1,
  .col-xs-2,
  .col-sm-2,
  .col-md-2,
  .col-lg-2,
  .col-xs-3,
  .col-sm-3,
  .col-md-3,
  .col-lg-3,
  .col-xs-4,
  .col-sm-4,
  .col-md-4,
  .col-lg-4,
  .col-xs-5,
  .col-sm-5,
  .col-md-5,
  .col-lg-5,
  .col-xs-6,
  .col-sm-6,
  .col-md-6,
  .col-lg-6,
  .col-xs-7,
  .col-sm-7,
  .col-md-7,
  .col-lg-7,
  .col-xs-8,
  .col-sm-8,
  .col-md-8,
  .col-lg-8,
  .col-xs-9,
  .col-sm-9,
  .col-md-9,
  .col-lg-9,
  .col-xs-10,
  .col-sm-10,
  .col-md-10,
  .col-lg-10,
  .col-xs-11,
  .col-sm-11,
  .col-md-11,
  .col-lg-11,
  .col-xs-12,
  .col-sm-12,
  .col-md-12,
  .col-lg-12 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
  }

  .col-xs-1,
  .col-xs-2,
  .col-xs-3,
  .col-xs-4,
  .col-xs-5,
  .col-xs-6,
  .col-xs-7,
  .col-xs-8,
  .col-xs-9,
  .col-xs-10,
  .col-xs-11,
  .col-xs-12 {
    float: left;
  }

  .col-xs-12 {
    width: 100%;
  }

  .visible-xs {
    display: none !important;
  }

  @media (min-width: 992px) {
    .col-md-1,
    .col-md-2,
    .col-md-3,
    .col-md-4,
    .col-md-5,
    .col-md-6,
    .col-md-7,
    .col-md-8,
    .col-md-9,
    .col-md-10,
    .col-md-11,
    .col-md-12 {
      float: left;
    }

    .col-md-6 {
      width: 50%;
    }
  }

  @media (min-width: 768px) {
    .col-sm-1,
    .col-sm-2,
    .col-sm-3,
    .col-sm-4,
    .col-sm-5,
    .col-sm-6,
    .col-sm-7,
    .col-sm-8,
    .col-sm-9,
    .col-sm-10,
    .col-sm-11,
    .col-sm-12 {
      float: left;
    }

    .col-sm-12 {
      width: 100%;
    }

    .col-sm-8 {
      width: 66.66666667%;
    }

    .col-sm-7 {
      width: 58.33333333%;
    }

    .col-sm-6 {
      width: 50%;
    }

    .col-sm-5 {
      width: 41.66666667%;
    }

    .col-sm-4 {
      width: 33.33333333%;
    }

    .col-sm-offset-2 {
      margin-left: 16.66666667% !important;
    }

    .col-sm-offset-1 {
      margin-left: 16.66666667% !important;
    }

    .col-sm-offset-0 {
      margin-left: 0 !important;
    }
  }

  @media (max-width: 480px) {
    .visible-xs {
      display: block !important;
    }

    .hidden-xs {
      display: none !important;
    }
  }

  ul li,
  ol li {
    list-style-type: none;
    line-height: 1.5em;
  }

  iframe {
    display: block;
    margin-left: auto;
    margin-right: auto;
  }

  .kc-article-content {
    p {
      position: relative;
      line-height: 1.5em;
    }

    .article-image {
      padding: 0 0 20px 20px;
      float: right;
      width: 624px;
      height: 352px;
    }

    .article-image-small {
      width: 312px;
      height: 176px;
    }
  }

  .bullet-list li {
    position: relative;
    color: ${Theme.colors.black};

    &::before {
      content: "\\2022";
    }

    &:nth-child(1n)::before {
      position: absolute;
      left: -1.2em;
      color: ${Theme.colors.dark_red};
      font-weight: bold;
    }
  }

  .numbered-list li {
    position: relative;
    color: ${Theme.colors.black};

    &::before {
      position: absolute;
      left: -1.2em;
      color: ${Theme.colors.dark_red};
      font-weight: bold;
    }

    &:nth-child(1)::before {
      content: "1";
    }

    &:nth-child(2)::before {
      content: "2";
    }

    &:nth-child(3)::before {
      content: "3";
    }

    &:nth-child(4)::before {
      content: "4";
    }

    &:nth-child(5)::before {
      content: "5";
    }

    &:nth-child(6)::before {
      content: "6";
    }

    &:nth-child(7)::before {
      content: "7";
    }

    &:nth-child(8)::before {
      content: "8";
    }

    &:nth-child(9)::before {
      content: "9";
    }

    &:nth-child(10)::before {
      content: "10";
    }
  }

  .c-bullet::before {
    content: '';
    border-style: solid;
    border-width: 0.05em 0.05em 0 0;
    display: inline-block;
    height: 0.45em;
    width: 0.45em;
    position: relative;
    top: 0.5em;
    transform: rotate(45deg);
    vertical-align: top;
    color: ${Theme.colors.red};
    margin-right: 1em;
  }

  .quote {
    margin: 40px 30px 40px 15px;
    padding: 10px 20px;
    border-left: solid 4px ${Theme.colors.dark_red};
    ${Mixin.font.MakoBold(20, 'bold')}
  }

  .sub-heading {
    margin: 0;
    ${Mixin.font.GothamBold(22, '600')}
    clear: both;
    transform: scale(1, 1.3);
  }

  .sub-heading-large {
    margin: 0 0 12px;
    ${Mixin.font.MakoBold(26, 600)}
    transform: scale(1, 1.3);
  }

  .sub-heading-small {
    margin: 1em 0 0;
    line-height: 1.5em;
    ${Mixin.font.MakoBold(14, 'bold')}
    transform: scale(1, 1.3);
  }

  .sub-heading-small + p {
    margin-top: 0;
  }

  .button {
    background-color: ${Theme.colors.white};
    color: ${Theme.colors.black};
    border: 2px solid #f44336;
    padding: 16px 32px;
    text-align: center;
    text-decoration: none;
    font-size: 16px;
    margin: 4px 2px;
    /* stylelint-disable-next-line property-no-vendor-prefix */
    -webkit-transition-duration: 0.4s;
    transition-duration: 0.4s;
    cursor: pointer;
    display: block;
    margin-left: auto;
    margin-right: auto;

    &:hover {
      background-color: #f44336;
      color: ${Theme.colors.white};
    }
  }

  .table-bot {
    border-left: 1px solid ${Theme.colors.black};
    border-bottom: 1px solid ${Theme.colors.black};
    border-spacing: 0;
    border-collapse: collapse;

    tr {
      th {
        font-weight: bold;
      }

      th,
      td {
        text-align: center;
        padding: 6px 16px;
        border: 1px solid ${Theme.colors.black};
        border-left: none;
        border-bottom: none;
      }
    }
  }

  @media (max-width: 992px) {
    .kc-article-content .article-image {
      width: 500px;
      height: 283px;
    }
  }

  @media (max-width: 768px) {
    .kc-article-content .article-image {
      width: 400px;
      height: 262px;
    }
  }

  @media (max-width: 480px) {
    .kc-article-content .article-image {
      width: 100%;
      clear: both;
      padding: 0 0 14px;
    }
  }
`

const TitlesWrapper = styled.div`
  max-width: 500px;
  margin: 0 0 30px;
`

const Subtitle = styled(H2)`
  text-align: left;
  margin: 0 0 60px;
  font-weight: 600;
`

const Title = styled(H1)`
  text-align: left;
  ${Mixin.font.GothamBold(26, 600)}
`

const ArticleAccordionWrapper = styled.div`
  width: 250px;
  margin: 0 40px 0 0;
`

const ArticleWrapper = styled.div`
  width: calc(100% - 250px - 40px);
  ${Media.mobile`
    width: auto;
  `}
`

const ArticleHeader = styled.div`
  display: flex;
  justify-content: space-between;
  ${Media.mobile`
    flex-direction: column-reverse;
  `}
`

const AppointmentButton = styled(Button)`
  display: flex;
  align-items: center;
  align-self: center;
  justify-content: space-between;
  padding: 7px 20px 8px;
  margin: 0;
  width: 335px;
  height: 46px;
  font-size: 16px;
  cursor: pointer;
  border-radius: 4px;
  ${Media.mobile`
    align-self: unset;
    height: unset;
    width: unset;
    padding: 8px 20px 8px;
    margin: 0 0 10px 0;
  `}
  ${props => props.bottomButton && css`
    margin: 30px 0 0 0;
    ${Media.mobile`
      width: 100%;
      margin: 30px 0 0 0;
    `}
  `}
`

const AppointmentIcon = styled(Icon)`
  width: 30px;
  ${Media.mobile`
    width: 20px;
  `}
`

const ArrowIcon = styled(Icon)`
  width: 10px;
  ${Media.mobile`
    width: 7px;
  `}
`

const ExploreTopicsButton = styled(Button)`
  padding: 10px 30px 10px;
  margin: 20px 0 80px 0;
  font-size: 16px;
  background-color: ${Theme.colors.white};
  color: ${Theme.colors.bright_red_new};
  border: 1px solid ${Theme.colors.bright_red_new};
  border-radius: 4px;
  cursor: pointer;
  line-height: 1.05em;
  letter-spacing: 0.05em;
  transform: scale(1, 1.3);
`
